import React from 'react';

import { DefinitionHeader } from 'components/common/fields/DefinitionHeader';
import { isEmptyObjValues } from 'utils/ramdaAdditions';
import { PersonCitizenship } from './PersonCitizenship';
import { PersonSourceForSys } from './PersonSourceForSys'

export const PersonAdditionalBlock = ({ citizenship, sourceForSys }) => !isEmptyObjValues({ citizenship, sourceForSys }) ? (
    <div>
        <DefinitionHeader translate="person.additional.title" iconType="map-marker" />
        <div className="panel-view">
            <PersonSourceForSys sourceForSys={sourceForSys} />
            <PersonCitizenship citizenship={citizenship} />
        </div>
    </div>
) : null;
